import React, { useContext, useEffect, useRef, useState } from "react";
import { useIntl, defineMessages, FormattedMessage } from "react-intl";
import { ListItem, CircularProgress, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { FormContext } from "./form";
import AddIcon from "@material-ui/icons/Add";
import { FollowUpEntryFormField } from "./followUpEntryFormField";
import { useFormStyles } from "./formFields";
import AddFollowUp from "./addFollowUp";
import EditPopup from "./EditPopup";
import { cloneDeep } from "lodash";
import { buttonDisabled } from "../../redux/task/taskActions";
import { connect, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import * as _ from "lodash";
import { duplicateCheckPopup, saveFollowUps } from "../../redux/followUps/followUpsActions";
import DuplicateTruckRollPopup from "../../components/workOrderActions/duplicateTruckRollWarningPopup";
import useActivityQuestions from "../activityQuestions/hooks/useActivityQuestions";
import { requestActivityQuestions } from "../../redux/activityQuestions/activityQuestionsActions";
import useCheckDuplicateWorkOrder from "../../hooks/useCheckDuplicateWorkOrder";
import useFollowUpsList from "../../hooks/useFollowupsList";
import useIsEndToEndEnabled from "../../hooks/useIsEndToEndEnabled";

const messages = defineMessages({
    addFollowUp: {
        id: "task-complete-form.add-follow-up-caption",
        defaultMessage: "Add follow-up",
        description: "Add follow-up caption",
    },
    close: {
        id: "admin.work-order-details.close",
        defaultMessage: "Close",
        description: "Admin work order close text",
    },
    open: {
        id: "admin.work-order-details.open",
        defaultMessage: "Open",
        description: "Admin work order open",
    },
    followups: {
        id: "wo-actions.follow-ups.title",
        defaultMessage: "Follow-Ups",
        description: "Follow-ups popup title",
    },
});

const useStyles = makeStyles((theme) => ({
    followUpTitleInc: {
        marginRight: "1%",
    },
    follupTitleDiv: {
        background: "#f4f4f4",
        padding: "4% 0%",
    },
}));

export const FollowUpsFormField = (props) => {
    const { field, reasons, data, setData, selectedReason, dueDate, duplicateWOCheck } = props;
    let moment = require("moment-business-days");
    moment.updateLocale("us", { workingWeekdays: [1, 2, 3, 4, 5] });
    const { followUpList, addFollowUp, updateFollowUp, popFollowup } = useFollowUpsList();
    const formServices = useContext(FormContext);
    const [openAdd, setOpenAdd] = useState(false);
    const [duplicateWorkOrderDTOList, setDuplicateWorkOrderDTOList] = useState([]);
    const [openDuplicatePopup, setOpenDuplicatePopup] = useState(false);
    const intl = useIntl();
    const dispatch = useDispatch();
    const [filteredReasons, setFilteredReasons] = useState(reasons);
    const editingFollowUpID = useRef("");
    const isEndToEndEnabled = useIsEndToEndEnabled(props.workOrderNumber);
    const { endToEndTypes } = useActivityQuestions();
    const { checkDuplicateWorkOrder } = useCheckDuplicateWorkOrder();

    useEffect(() => {
        if (!isEndToEndEnabled) {
            setFilteredReasons(reasons.filter((reason) => !endToEndTypes.includes(reason.followUpTypeID)));
        } else {
            // added else because in the first two renders isEndToEndEnabled returning false, unintentionally filtering reasons.
            setFilteredReasons(reasons);
        }
    }, [isEndToEndEnabled, reasons]);

    useEffect(() => {
        if (followUpList.length) {
            formServices.value[field] = followUpList;
        }
    }, [followUpList]);

    useEffect(() => {
        let duplicateWoList = props.followUpResponse?.body?.createdFollowUpList[0]?.duplicateWorkOrdersDTO?.duplicateWorkOrderDTOList;
        if (!!duplicateWoList && duplicateWoList.length > 0) {
            setDuplicateWorkOrderDTOList(props.followUpResponse);
            setOpenDuplicatePopup(props.isOpen);
        }
    }, [props.followUpResponse, props.isOpen]);

    useEffect(() => {
        if (props.isMandatory) {
            if (followUpList?.length) {
                props.buttonDisabled(false);
            } else {
                props.buttonDisabled(true);
            }
        }
        props.sendData(followUpList);
    }, [props.isMandatory, followUpList]);

    const updateReasons = (reason, index) => {
        const followUpCopy = cloneDeep(followUpList[index]);
        if (reason.followUpTypeID && endToEndTypes.includes(Number(reason.followUpTypeID)) && followUpCopy.uuid) {
            dispatch(requestActivityQuestions(Number(reason.workActivityID), followUpCopy.uuid));
        }
        followUpCopy.followUpTpyeId = followUpCopy.id = reason.followUpTypeID;
        followUpCopy.hasActivityQuestions = reason.hasActivityQuestions ?? false;
        if (reason.newWorkOrderRequired) {
            checkDuplicateWorkOrder({ ...followUpCopy, id: null }, [], "labourer_complete");
        } else {
            followUpCopy.duplicateWorkOrdersDTO = null;
        }
        updateFollowUp(followUpCopy);
    };

    const fetchPriority = (followUp, selectedReasonId) =>
        Array.isArray(followUp?.overRidePriority)
            ? _.get(_.find(followUp.overRidePriority, { completionCode: selectedReasonId }), "priority", null)
            : null;

    const handleDoneAddingFollowup = (followUpReason, comments, uuid) => {
        updateFollowUp({
            uuid,
            comments: comments,
            id: followUpReason.followUpTypeID,
            followUpTpyeId: followUpReason.followUpTypeID,
            hasActivityQuestions: followUpReason.hasActivityQuestions,
            creationDate: moment().format("YYYY-MM-DD HH:mm:ss"),
            dueDate: followUpReason?.leadTime ? moment()?.businessAdd(followUpReason?.leadTime)._d : moment(),
            priority: fetchPriority(followUpReason, selectedReason),
            new: true,
            isFollowUpActive: true,
            isHide: false,
            newWorkOrderRequired: followUpReason.newWorkOrderRequired,
            ...(followUpReason.newWorkOrderRequired === false && { duplicateWorkOrdersDTO: null }),
        });

        setOpenAdd(false);
    };

    const proceedAddingFollowUp = () => {
        setOpenDuplicatePopup(false);
        props.duplicateCheckPopup(false);
        let list = props.followUpResponse?.body?.createdFollowUpList[0]?.duplicateWorkOrdersDTO;
        if (editingFollowUpID.current) {
            // this is edit existing followup flow.
            updateFollowUp({
                ...followUpList.find((f) => f.uuid === editingFollowUpID.current),
                validatedForDoubles: true,
                duplicateWorkOrdersDTO: list,
            });
            editingFollowUpID.current = "";
        } else if (followUpList.length > 0) {
            // this is add new followup flow, hence just update the last followup.
            updateFollowUp({
                ...followUpList[followUpList.length - 1],
                validatedForDoubles: true,
                duplicateWorkOrdersDTO: list,
            });
        }
    };
    const proceedRemovingFollowUp = () => {
        setOpenDuplicatePopup(false);
        props.duplicateCheckPopup(false);
        setOpenAdd(false);
        popFollowup();
    };

    const classes = Object.assign(useStyles(), useFormStyles());

    if (!props?.workorderData?.id) {
        return (
            <Grid container justifyContent="center" alignItems="center" style={{ minHeight: 100 }}>
                <CircularProgress />
            </Grid>
        );
    }

    return (
        <>
            {followUpList
                ?.filter((followUp) => followUp?.isFollowUpActive && followUp?.new)
                ?.map((followUp, index) => (
                    <>
                        <div className={classes.follupTitleDiv}>
                            <span className={classes.followUpTitleInc}>{intl.formatMessage(messages.followups)}</span>
                            <span>{index + 1}</span>
                        </div>
                        <FollowUpEntryFormField
                            followUp={followUp}
                            reasons={filteredReasons}
                            index={index}
                            onReasonChange={(reason) => {
                                updateReasons(reason, index);
                                editingFollowUpID.current = followUp.uuid;
                            }}
                        />
                    </>
                ))}
            <ListItem>
                <div className={classes.formElement}>
                    <div className={classes.formInfo}>
                        <div className={classes.infoHeader}>{intl.formatMessage(messages.addFollowUp)}</div>
                    </div>
                    <EditPopup
                        title={<FormattedMessage id="wo-actions.follow-ups.title" defaultMessage="Follow-Ups" description="Follow-ups popup title" />}
                        icon={
                            <AddIcon
                                color="primary"
                                onClick={() => {
                                    setOpenAdd(true);
                                    addFollowUp();
                                }}
                            />
                        }
                        content={
                            <AddFollowUp
                                reasons={filteredReasons}
                                onDone={handleDoneAddingFollowup}
                                workorderData={props.workorderData}
                                followUp={followUpList[followUpList.length - 1]}
                            />
                        }
                        closePopup={openAdd}
                        data={data}
                        setData={setData}
                        selectedReason={selectedReason}
                        dueDate={dueDate}
                        duplicateWOCheck={duplicateWOCheck}
                    />
                </div>
            </ListItem>

            {openDuplicatePopup && (
                <DuplicateTruckRollPopup
                    followUpsResponse={duplicateWorkOrderDTOList}
                    open={openDuplicatePopup}
                    setOpen={() => setOpenDuplicatePopup(openDuplicatePopup)}
                    handleClose={proceedAddingFollowUp}
                    handleCancel={proceedRemovingFollowUp}
                    keycloak={props.keycloak}
                />
            )}
        </>
    );
};
const mapStateToProps = (state) => ({
    lang: state.domain.locale.lang,
    keycloak: state.login.keycloak,
    reasons: state.followUps.followUpReasons ? state.followUps.followUpReasons : [],
    FirstfollowupReason: state.followUps.FirstfollowupReason,
    userProfile: state.login.userProfile,
    userInfo: state.login.userInfo,
    technicianInfo: state.login.technicianInfo,
    dueDate: state.followUps.dueDate,
    followUpResponse: state.followUps.followUpsResponse,
    workorderData: state.tasks.workorderData.workorderData,
    isOpen: state.followUps.isOpen,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            buttonDisabled,
            saveFollowUps,
            duplicateCheckPopup,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(FollowUpsFormField);
